module.exports = __webpack_public_path__ + "d38cb2aa3986495635c614ccc412673a.png";